import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { setLenis } from "@/lib/scroll";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Collection from "@/components/Collection";
import Story from "@/components/Story";
import BrewGuide from "@/components/BrewGuide";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <CartProvider>
      <div className="relative min-h-screen bg-stone-950 font-sans text-stone-100">
        <div className="grain" aria-hidden="true" />
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <Collection />
          <Story />
          <BrewGuide />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <CartDrawer />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    </CartProvider>
  );
}

export default App;
